import { CheckCircle } from 'lucide-react';
import type { IExecutedAction } from '../../store/useChatStore';

interface ActionCardProps {
  action: IExecutedAction;
}

function formatToolName(name: string): string {
  switch (name) {
    case 'create_area': return 'Area created';
    case 'create_task': return 'Task created';
    case 'create_tasks_batch': return 'Tasks created';
    case 'update_task': return 'Task updated';
    default: return name;
  }
}

function getResultSummary(action: IExecutedAction): string {
  const data = action.result;
  if (!data) return '';

  if (Array.isArray(data)) {
    return `${data.length} items`;
  }

  if (typeof data === 'object' && data !== null) {
    const record = data as Record<string, unknown>;
    if (record.name) return String(record.name);
  }

  return '';
}

export function ActionCard({ action }: ActionCardProps) {
  const label = formatToolName(action.toolName);
  const summary = getResultSummary(action);

  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-2xl bg-emerald-50 dark:bg-emerald-500/10 border border-emerald-200 dark:border-emerald-500/30 text-sm">
      <CheckCircle size={16} className="text-emerald-600 dark:text-emerald-300 flex-shrink-0" aria-hidden="true" />
      <span className="text-emerald-800 dark:text-emerald-200 font-semibold">{label}</span>
      {summary && (
        <span className="text-emerald-700 dark:text-emerald-300 truncate">{summary}</span>
      )}
    </div>
  );
}
